import { adminRolesAPI } from 'api/admin-roles';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

export function useCreateAdminRole() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: adminRolesAPI.create,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY.FIND_ONE_ADMIN_ROLE, data);
      toast(locales.createSuccess, { type: 'success' });
    },
  });

  return mutation;
}
